import { Box, Grid, Typography, useTheme } from "@mui/material";
import RegisterNewStep1, {
  RegisterNewStep1Props,
} from "./step-1/setp1.component";
import Logo from "@assets/webp/logo/logo.component";
import { Suspense, useState, useEffect } from "react";
import Stepper from "./components/stepper/stepper.component";
import RegisterNewStep2 from "./step-2/setp2.component";
import Instructions from "./components/instructions/instructions.component";
import { useTranslation } from "react-i18next";

const RegisterNew = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [formStep, setFormStep] = useState(1);
  const goToNextStep = () => {
    if (formStep > 2 || formStep < 1) console.error("Ilegal step");
    setFormStep(formStep + 1);
  };
  const renderSubHeading = (step: number) => {
    switch (step) {
      case 1:
        return t("Personal information");
      case 2:
        return t("Business information");
    }
  };
  const registerNewStep1Props: RegisterNewStep1Props = {
    goToNextStep,
  };
  const registerNewStep2Props: RegisterNewStep1Props = {
    goToNextStep,
  };
  const renderForm = (step: number) => {
    switch (step) {
      case 1:
        return <RegisterNewStep1 {...registerNewStep1Props} />;
      case 2:
        return <RegisterNewStep2 {...registerNewStep2Props} />;
    }
  };

  useEffect(() => {
    document.title = "NetNut Portal Registration | netnut.io";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Register to unlock netnut.io premium proxy solutions! Ensure seamless, secure, and scalable web operations with our advanced proxy network."
      );
    } else {
      const meta = document.createElement("meta");
      meta.name = "description";
      meta.content =
        "Register to unlock netnut.io premium proxy solutions! Ensure seamless, secure, and scalable web operations with our advanced proxy network.";
      document.head.appendChild(meta);
    }
  }, []);

  return (
    <Grid
      container
      direction="column"
      sx={{ background: theme.palette.background.default, minHeight: "100vh" }}
    >
      <Grid container sx={{ mx: { xs: 0, sm: 6 } }} pt={3}>
        <Grid
          item
          container
          xs={12}
          mb={1}
          lg={7}
          xl={7}
          sx={{ justifyContent: { xs: "center", sm: "flex-start" } }}
        >
          <Box sx={{ marginLeft: -1 }}>
            <Logo />
          </Box>
        </Grid>
        <Grid container item xs={12} sm={10}>
          <Grid item mb={3} lg={12} xl={8} xs={12}>
            <Typography
              color="text.secondary"
              variant="h1"
              sx={{ textAlign: { xs: "center", sm: "left" } }}
            >
              {t("Registration")}
            </Typography>
            <Typography
              variant="h4"
              color="text.hint"
              sx={{ textAlign: { xs: "center", sm: "left" } }}
            >
              {renderSubHeading(formStep)}
            </Typography>
            <Grid item xs={12}>
              <Stepper currentStep={formStep} />
            </Grid>
            <Suspense fallback="...Is loading">{renderForm(formStep)}</Suspense>
          </Grid>
          <Grid
            item
            container
            justifyContent="center"
            lg={4}
            xl={4}
            xs={12}
            pb={3}
          >
            <Instructions step={formStep} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default RegisterNew;
